export default "__VITE_ASSET__B$fhVeL6__"